const capitalize = (value : string) : string => `${value.charAt(0).toUpperCase() + value.slice(1)}`

const formatCurrency = (value : string, locale : string = 'de-DE', currency : string = 'EUR') : string => {
  const normalizedValue = value.replace(',', '.')
  const numValue = parseFloat(normalizedValue)
  if (Number.isNaN(numValue)) {
    return value
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numValue)
}
export { formatCurrency }
export default capitalize
